import React from 'react';
import { ErrorMessage, Grid, Header1Text, PagerWrapper } from 'ui-toolkit';
import { IVendorTaxCertificationsData } from '../../types/vendorDashboard/IVendorTaxCertifications';
import {
  eTaxCertificationRequestStatus,
  vendorTaxReqInitialStatuses,
} from '../../types/order/title/eTaxCertificationRequestStatus';
import { ISearchOrderTaxCertReqSettingsData } from '../../types/vendorDashboard/ISearchOrderTaxCertReqSettingsData';
import { VendorDashTabs } from '../../components/vendorDashboard/VendorDashTabs';
import { VendorTaxCertificationRequestsFilter } from '../../components/vendorDashboard/VendorTaxCertificationRequestsFilter';
import { OrderSearchForm } from '../../components/vendorDashboard/comments/OrderSearchForm';
import { TaxCertificationsTable } from '../../components/vendorDashboard/TaxCertificationsTable';
import { ISearchOrdersSpecificationData } from '../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';

interface IVendorTaxCertificationsPageProps {
  pageError?: Error;
  taxCerts: IVendorTaxCertificationsData;
  searchSettings: ISearchOrderTaxCertReqSettingsData;
  loadingTaxCerts: boolean;
  onFilterPayoff: (status: eTaxCertificationRequestStatus[]) => void;
  onPageSizeUpdate: (pageSize: number) => void;
  onPageUpdate: (page: number) => void;
  onSearchTaxCerts: (value: ISearchOrdersSpecificationData) => void;
}

export const VendorTaxCertificationsPage: React.FC<IVendorTaxCertificationsPageProps> = ({
  pageError,
  taxCerts,
  searchSettings,
  loadingTaxCerts,
  onFilterPayoff,
  onPageSizeUpdate,
  onPageUpdate,
  onSearchTaxCerts,
}) => {
  return (
    <>
      <ErrorMessage message={pageError?.message} />
      <VendorDashTabs
        activeTabIndex={2}
        prefix={<Header1Text>Orders</Header1Text>}
        suffix={
          <VendorTaxCertificationRequestsFilter
            onFilterPayoff={onFilterPayoff}
            statuses={searchSettings.statuses}
            filterOptions={vendorTaxReqInitialStatuses}
            defaultStatuses={vendorTaxReqInitialStatuses}
          />
        }
      >
        <Grid>
          <OrderSearchForm onSearchOrder={onSearchTaxCerts} />
          <PagerWrapper
            onPageSizeChange={onPageSizeUpdate}
            onPageChange={onPageUpdate}
            pageSize={searchSettings.pageSize}
            page={searchSettings.pageNumber}
            total={taxCerts.total}
            disabled={loadingTaxCerts}
          >
            <TaxCertificationsTable taxCerts={taxCerts.taxCertificationRequests} loading={loadingTaxCerts} />
          </PagerWrapper>
        </Grid>
      </VendorDashTabs>
    </>
  );
};
